import { NativeAssetInfo } from '@/config/chain/types'
import { AaveData } from '@/features/sparklend/common/data/market-info/aave-data-layer/query'
import { MarketInfo, UserPositionSummary } from '@/features/sparklend/common/data/market-info/marketInfo'
import { updatePositionSummary } from '@/features/sparklend/common/data/market-info/updatePositionSummary'
import { SparkLendToken } from '@/features/sparklend/tokens/SparkLendToken'

export interface GetUpdatedUserSummaryParams {
  useAsCollateral: boolean
  token: SparkLendToken
  marketInfo: MarketInfo
  aaveData: AaveData
  nativeAssetInfo: NativeAssetInfo
}

export function getUpdatedUserSummary({
  useAsCollateral,
  token,
  marketInfo,
  aaveData,
  nativeAssetInfo,
}: GetUpdatedUserSummaryParams): UserPositionSummary {
  const reserve = marketInfo.findOneReserveByToken(token)

  return updatePositionSummary({
    reservesWithUseAsCollateralFlag: [
      {
        reserve,
        useAsCollateral,
      },
    ],
    marketInfo,
    aaveData,
    nativeAssetInfo,
  })
}
